export function replaceRoleLabel(label: string, title: string) {
  return label.replace('{title}', title || '____');
}

// Removes http:// or https://, trailing slash, and spaces on both ends from the
// homepage URL.
// Returns as is if it's undefined, null or empty string.
export function sanitizeHomepageUrl(homepageUrl?: string | null) {
  return homepageUrl
    ? homepageUrl
        .trim()
        .replace(/^https?:\/\//, '')
        .replace(/\/$/, '')
        .trim()
    : homepageUrl;
}
